import { render, staticRenderFns } from "./DetailSale.vue?vue&type=template&id=d75ac026&scoped=true&"
import script from "./DetailSale.vue?vue&type=script&lang=js&"
export * from "./DetailSale.vue?vue&type=script&lang=js&"
import style0 from "./DetailSale.vue?vue&type=style&index=0&id=d75ac026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75ac026",
  null
  
)

export default component.exports